import { Component, Input, OnInit, inject, DestroyRef } from '@angular/core';
import { TokenizationService } from 'src/app/shared/services/tokenization/tokenization.service';
import { ExternalService } from 'src/app/shared/services/external/external.service';
import { LoginService } from 'src/app/shared/services/login/login.service';
import { FeedsService } from 'src/app/shared/services/feeds/feeds.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as _ from 'lodash';
import * as moment from 'moment';
import { NgIf, NgFor } from '@angular/common';
@Component({
    selector: 'app-information-panel',
    templateUrl: './information-panel.component.html',
    styleUrls: ['./information-panel.component.scss'],
    imports: [NgIf, NgFor]
})
export class InformationPanelComponent implements OnInit {
  @Input() feedData: any = {};
  @Input() feedId: string = '';
  @Input() brandDetails: any = {}
  destroyRef = inject(DestroyRef);
  customerId: string = '';
  feedDetails: any = {}
  transactionDetails: any = []
  profileDetails: any = []
  notifactionDetails: any = []
  fieldDefinitionMapping: any = {}
  notificationDetail: any = {}
  isTSEnabled: boolean = false;
  isUnTokenisedInfo: boolean = false;
  notificationKeyToBeFetched: any = {
    "notify_channel": {
      "title": "Notification Channel"
    },
    "last_trial_attempt": {
      "title": "Attempts"
    },
    "utm_medium": {
      "title": "Response Medium"
    },
    "last_trial_sent": {
      "title": "Last Notified Date",
      "type": "date"
    },
    "utm_term": {
      "title": "Responded on",
    },
    "trial_1": {
      "title": "Invitation Sent Date",
      "type": "date"
    },
    "trial_2": {
      "title": "Reminder1 Sent Date",
      "type": "date"
    },
    "trial_3": {
      "title": "Reminder2 Sent Date",
      "type": "date"
    },
    "trial_4": {
      "title": "Reminder3 Sent Date",
      "type": "date"
    },
    "trial_5": {
      "title": "Reminder4 Sent Date",
      "type": "date"
    },
    "trial_6": {
      "title": "Reminder5 Sent Date",
      "type": "date"
    },
    "trial_7": {
      "title": "Reminder6 Sent Date",
      "type": "date"
    },
    "trial_8": {
      "title": "Reminder7 Sent Date",
      "type": "date"
    }
  }
  selectedFeedDetail: any = {};
  customerDetails: any = {};
  constructor(
    private _tokenization: TokenizationService,
    private _external: ExternalService,
    private _loginService: LoginService,
    private _feedsService: FeedsService
  ) { }

  ngOnInit(): void {

  }

  ngOnChanges() {
    this.resetData();
    this.feedData = Helpers.deepClone(this.feedData);
    this.brandDetails = (!_.isEmpty(this.brandDetails)) ? this.brandDetails : Helpers.brandDetails;
    this.feedDetails = _.get(this.feedData, 'feed', {})
    this.customerId = _.get(this.feedDetails, 'litmus_processed_data.tag_private_customer_id');
    const fieldDefinition: any = _.get(this.brandDetails, 'field_definitions', []);

    if (_.get(this.brandDetails, "security_settings.tokenization_server.secret_key")) {
      this.isTSEnabled = true;
    }
    if (fieldDefinition.length) {
      this.fieldDefinitionMapping = this.getFieldDefinitionsiMapping(fieldDefinition);
      this.prepareCustomerDetail(this.feedData);
      this.prepareNotificationDetail(this.feedData);
      // Variable to check and format date: If tag will be either feedback_request_date or type date, format it.
      var tagsWithDate = _.filter(this.brandDetails.field_definitions, { "type": "date" }) || [];
      var tags = this.feedData.tags;
      var formatedDate = null;
      var dateFormat = null;
      // Get the name of zone name. Eg: Asia/Calcutta
      var brandOffsetDetail = this.getBrandZoneName(this.brandDetails);
      if (tags) {
        for (var tag in tags) {
          // Ignore custom parameter detail
          if (this.fieldDefinitionMapping.get(tag) && (tag.indexOf("ltms_custom_field_") == -1) && (_.get(this.fieldDefinitionMapping.get(tag), "show_in_inbox_detail") != false)) {
            formatedDate = null;
            var dateTypeField = _.filter(tagsWithDate, { "field_id": tag });
            dateTypeField = dateTypeField[0];
            if (tag == "feedback_request_date" || dateTypeField) {
              dateFormat = _.get(dateTypeField, "format") || "DD MMM 'YY HH:mm:ss";
              formatedDate = this.getDateBasedOnFormat(brandOffsetDetail, tags[tag], dateFormat);
            }
            if (tag != "tag_private_customer_id" && tag != "tag_customer_id") {
              var tagValue = (_.get(tags, tag + ".0") && !_.isObject(tags[tag][0])) ? tags[tag].toString() : this.capitalizeFirstLetter(tags[tag] || "NA");
              tagValue = (tagValue && tagValue.length) ? tagValue : "NA";
              this.transactionDetails.push({
                "field_id":this.fieldDefinitionMapping.get(tag).field_id,
                'header': this.fieldDefinitionMapping.get(tag).name,
                'value': formatedDate || tagValue
              });
            }
          }
        }
        // txn data sort by header.
        if(this.transactionDetails && this.transactionDetails.length > 0){
          this.transactionDetails = _.sortBy(this.transactionDetails, [function (o) { return o.header; }]);
        }
      }
    }

  }

  resetData() {
    this.transactionDetails = []
    this.profileDetails = []
    this.notifactionDetails = []
  }
  prepareCustomerDetail(feedDetail) {
    var userId = _.get(feedDetail, "feed.feed_by_id");
    var userDetail = _.filter(_.get(feedDetail, "users"), { "_id": userId });
    userDetail = (userDetail.length) ? userDetail[0] : {};
    var untokenisedCustomerInfo = _.get(this, "customerDetailscustomerDetailscustomerDetails") || {};
    this.isUnTokenisedInfo = (_.isEmpty(untokenisedCustomerInfo)) ? false : true;
    // Add fields only if, it's show_in_inbox_detail is true
    if (_.get(this.fieldDefinitionMapping.get("name"), "show_in_inbox_detail") != false) {
      let customer_name = untokenisedCustomerInfo["name"] || userDetail["name"] || _.get(feedDetail, "feed.feedback_request_data.tag_private_user_name") || _.get(feedDetail, "user.name") || 'Anonymous';
      this.profileDetails.push({
        header: _.get(this.fieldDefinitionMapping.get("name"), "name") || "Customer Name",
        value: this.capitalizeFirstLetter(customer_name)
      });
    }

    if (_.get(this.fieldDefinitionMapping.get("email_address"), "show_in_inbox_detail") != false) {
      this.profileDetails.push({
        header: _.get(this.fieldDefinitionMapping.get("email_address"), "name") || "Email ID",
        value: untokenisedCustomerInfo["email_address"] || userDetail["email_address"] || _.get(feedDetail, "user.email_address") || "NA"
      });
    }

    if (_.get(this.fieldDefinitionMapping.get("phone_number"), "show_in_inbox_detail") != false) {
      this.profileDetails.push({
        header: _.get(this.fieldDefinitionMapping.get("phone_number"), "name") || "Mobile Number",
        value: untokenisedCustomerInfo["phone_number"] || userDetail["phone_number"] || _.get(feedDetail, "user.phone_number") || "NA"
      });
    }

    if (_.get(this.fieldDefinitionMapping.get("customer_id"), "show_in_inbox_detail") != false) {
      this.profileDetails.push({
        header: _.get(this.fieldDefinitionMapping.get("tag_private_customer_id"), "name") || _.get(this.fieldDefinitionMapping.get("tag_customer_id"), "name") || _.get(this.fieldDefinitionMapping.get("customer_id"), "name") || "Customer Id",
        value: untokenisedCustomerInfo["tag_private_customer_id"] || userDetail["tag_customer_id"] || userDetail["customer_id"] || _.get(feedDetail, "user.customer_id") || "NA"
      })
    }
  }

  prepareNotificationDetail(feedResponse) {
    var litmusProcessedData = _.get(feedResponse, "feed.litmus_processed_data");
    this.notificationDetail = {};
    if (!_.isEmpty(litmusProcessedData)) {
      // Get the name of zone name. Eg: Asia/Calcutta
      var brandOffsetDetail = this.getBrandZoneName(this.brandDetails);
      for (let litmusProcessedKey in litmusProcessedData) {
        // if key is present in notificationKeyToBeFetched then push it to the array
        if (this.notificationKeyToBeFetched[litmusProcessedKey]) {
          const type = _.get(this.notificationKeyToBeFetched, litmusProcessedKey + ".type") || "";
          let value: any = litmusProcessedData[litmusProcessedKey]
          if (value && typeof value == 'string' && value.toLowerCase().indexOf('trial') >= 0) {
            value = value.replace('trial', 'attempt').replace('_', ' ');
          }
          this.notifactionDetails.push({
            header: _.get(this.notificationKeyToBeFetched, litmusProcessedKey + ".title"),
            value: (type == "date")
              ? this.getDateBasedOnFormat(brandOffsetDetail, litmusProcessedData[litmusProcessedKey], "DD MMM 'YY HH:mm:ss")
              : this.capitalizeFirstLetter(value)
          });
        }
      }
    }
  }

  getFieldDefinitionsiMapping(fieldDefinition: any) {
    let map = new Map();
    _.each(fieldDefinition, (field: any) => {
      map.set(field.field_id, field)
    })
    return map;
  }

  capitalizeFirstLetter(string) {
    if (_.isString(string)) {
      return string && string.charAt(0).toUpperCase() + string.substring(1);
    } else {
      return string;
    }
  }

  getBrandZoneName(brandDetail) {
    var brandOffset = _.get(brandDetail, 'default_time_zone.offset', 0);
    var brandTimezone = _.get(brandDetail, 'default_time_zone.timezone', 'UTC');;
    return { "name": brandTimezone, "offset": brandOffset };
  }

  getTimeByOffset(offset, time, format) {

    if (format == false && format != undefined) {
      return moment.utc(time).utcOffset(-offset)
    }

    if (!format) {
      format = "DD MMM 'YY HH:mm:ss";
    }
    return moment.utc(time).utcOffset(-offset).format(format)
  }

  getDateBasedOnFormat(brandOffsetName, value, format) {
    var formatedDate = value;
    if (brandOffsetName["name"] && brandOffsetName["offset"]) {
      formatedDate = this.getTimeByOffset(brandOffsetName["offset"], value, format) + " (" + brandOffsetName["name"].toString() + ")";
    }
    return formatedDate;
  }

  viewUserProfile(event: any, customerId: string) {
    event.preventDefault()
    var feedId = _.get(this.feedDetails, "_id")
    var requestType = _.get(this.feedDetails, "litmus_processed_data.tag_request_type")
    //check if customerId is defined or not. Also, check the case of tokenisation(WHether the tokenised data already fetched or not)
    if (customerId && (!this.isTSEnabled || (this.isTSEnabled && !this.isUnTokenisedInfo))) {
      //get the api url to get the user profile info from TS
      this.getApiUrlToConvertUserProfile((tsApiUrl) => {
        if (tsApiUrl) {
          let loginResponse = _.get(Helpers, 'managerDetails', {});

          //check if manager have logged and have user access
          if (loginResponse && loginResponse.isManagerLoggedIn && loginResponse.manager && loginResponse.manager.manager_access) {
            //call method to get the user profile details
            this.getUserProfileDetails(customerId, tsApiUrl, loginResponse, feedId, requestType);
          } else {
            this._loginService.logout();
          }
        } else {
          Helpers.smallAlertBox("Error", "Invalid tokenization server configs.", "error");
        }
      });
    } else {
      // lwFeedDetailsVm.pagerBusyForTokenisationCall = false;
      Helpers.smallAlertBox("Error", "User token not available on user details.", "error");
    }
  }

  getApiUrlToConvertUserProfile(cb) {
    //get the api url to decript the user info from tokenization server details
    if (_.hasIn(this.brandDetails, "security_settings.tokenization_server.user_token_url")) {
      cb(_.get(this.brandDetails, "security_settings.tokenization_server.user_token_url"));
    } else {
      cb();
    }
  }

  getUserProfileDetails(customerId, tsApiUrl, response, feedId, requestType) {
    //get the unique auth token from LitmusWorld server
    this.getAuthToken(this.brandDetails._id, customerId, (authKey) => {
      //check if authKey is defined or not
      if (authKey) {
        //call the configured tokenization server api to get the user details from customer_id
        this._external.getUserProfile(this.brandDetails._id, customerId, authKey, response.manager._id, tsApiUrl, feedId, requestType).subscribe((response) => {
          // lwFeedDetailsVm.pagerBusyForTokenisationCall = false;
          //check if api response is success or not
          if (_.get(response, 'user.code') == 0 && _.has(response, 'user.user') && !_.isEmpty(response.user.user)) {
            // //if success and scope have feed details and user details then set the user details to show on user profile details
            var usersList = _.union(this.feedData.managers, this.feedData.users);
            const user = _.find(usersList, { _id: this.feedData.feed.feed_by_id })
            if (!_.isEmpty(user)) {
              // if(!Utils.getProp(lwFeedDetailsVm, "selectedFeedDetail")){
              //     lwFeedDetailsVm.selectedFeedDetail = {};
              // }
              this.profileDetails = [];
              var userDetail = _.get(response, 'user.user');
              // this.customerDetails = {
              //   "name": _.get(userDetail, "name") || "NA",
              //   "nameForEllipsis": (userDetail && userDetail.name && userDetail.name != "null") ? (userDetail.name.slice(0, 12) + "...") : "NA",
              //   "email_address": _.get(userDetail, "email_address") || "NA",
              //   "emailForEllipsis": (userDetail && userDetail.email_address && userDetail.email_address != "null") ? (userDetail.email_address.slice(0, 12) + "...") : null, //"NA",
              //   "phone_number": _.get(userDetail, "phone_number") || "NA",
              //   "phoneForEllipsis": (userDetail && userDetail.phone_number && userDetail.phone_number != "null") ? (userDetail.phone_number.slice(0, 12) + "...") : null, //"NA",
              //   "customer_id": _.get(userDetail, "customer_id") || "NA",
              //   "customerIdForEllipsis": (userDetail && userDetail.customer_id && userDetail.customer_id != null) ? (userDetail.customer_id.slice(0, 12) + "...") : null, //"NA",
              // }
              if (_.get(this.fieldDefinitionMapping.get("name"), "show_in_inbox_detail") != false) {
                let customer_name = _.get(userDetail, "name") || "NA";
                this.profileDetails.push({
                  header: _.get(this.fieldDefinitionMapping.get("name"), "name") || "Customer Name",
                  value: this.capitalizeFirstLetter(customer_name)
                });
              }

              if (_.get(this.fieldDefinitionMapping.get("email_address"), "show_in_inbox_detail") != false) {
                this.profileDetails.push({
                  header: _.get(this.fieldDefinitionMapping.get("email_address"), "name") || "Email ID",
                  value: _.get(userDetail, "email_address") || "NA"
                });
              }

              if (_.get(this.fieldDefinitionMapping.get("phone_number"), "show_in_inbox_detail") != false) {
                this.profileDetails.push({
                  header: _.get(this.fieldDefinitionMapping.get("phone_number"), "name") || "Mobile Number",
                  value: _.get(userDetail, "phone_number") || "NA"
                });
              }

              if (_.get(this.fieldDefinitionMapping.get("customer_id"), "show_in_inbox_detail") != false) {
                this.profileDetails.push({
                  header: _.get(this.fieldDefinitionMapping.get("tag_private_customer_id"), "name") || _.get(this.fieldDefinitionMapping.get("tag_customer_id"), "name") || _.get(this.fieldDefinitionMapping.get("customer_id"), "name") || "Customer Id",
                  value: _.get(userDetail, "customer_id") || "NA"
                })
              }
              if (this['selectedFeedDetail'] == undefined) {
                this['selectedFeedDetail'] = {};
                this.selectedFeedDetail['customerDetails'] = {};
              }
              // this.selectedFeedDetail["customerDetails"] = this.customerDetails;
              // this.feedData["customerDetails"] = this.customerDetails;


              //hide the view profile button
              // lwFeedDetailsVm.isTSEnabled = false;
              this.isUnTokenisedInfo = true;
            } else {
              Helpers.smallAlertBox("Error", "User profile not available.", "error");
            }
          } else {
            //TODO: show alert for Error: Error while getting the user profile details from tokenization server
            Helpers.smallAlertBox("Error", "Error while getting user profile.", "error");
          }
        }, (error) => {
          //TODO: show alert for Errogr: Error while getting the auth keys
          Helpers.smallAlertBox("Error", "Error while getting user profile.", "error");
        });
      } else {
        //TODO: show alert for Errogr: Error while getting the auth keys
        Helpers.smallAlertBox("Error", "Error while getting user profile.", "error");
      }
    });
  }

  getAuthToken(brandId, customerId, cb) {
    //get the auth key from LitmusWorld server
    this._tokenization.getAuthKey(brandId, customerId).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((response: any) => {
      //check if api response is success or not
      // {"code":0,"data":{"auth_key":"a62ec995-4097-4c31-84ec-73841507f490","code":0}}
      if (response.code == 0 && _.get(response, "data.code") == 0 && _.get(response, 'data.auth_key')) {
        //return the auth key
        cb(_.get(response, "data.auth_key"));
      } else {
        //return the auth key
        cb();
      }
    }, (error: any) => {
      console.error("Error: error while trying to get auth key.")
    });
  }

  isEllipsisActive(field: any) {
    const el = document.getElementById(field.field_id);
    if (field.showMore) {
      return true
    } else if (el) {
      return (el.offsetHeight < el.scrollHeight)
    } else {
      return false
    }
  }

  changeFieldView(event: any, field: any) {
    event.preventDefault();
    if (field.showMore) {
      field.showMore = false;
    } else {
      field.showMore = true
    }
  }
}
